import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const MostviewBoxWrap = styled.div``

export const MostviewList = styled.ul`
    list-style: none;
    display: flex;
    width: 100%;
`

export const MostviewItem = styled.li`
    @media screen and (max-width: 767px) {
        display: flex;
    }

    @media screen and (max-width: 475px) {
        margin-bottom: 8px;
        padding-bottom: 5px;
        border-bottom: 1px solid #d8d8d8;
    }
`

export const MostviewImageLink = styled(Link)`
    text-decoration: none;
`

export const MostviewImage = styled.img`
    height: 117px;
    width: 100%;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        height: 106px;
    }

    @media screen and (max-width: 767px) {
        width: 165px;
        height: 103px;
    }

    @media screen and (max-width: 374px) {
        width: 128px;
        height: 80px;
    }
`
export const MostviewBody = styled.div`
    margin-top: 10px;
    padding-bottom: 12px;
    display: flex;

`

export const MostviewNumber = styled.span`
    color: #fff;
    font-size: 26px;
    font-weight: bold;
    background-color: #e32;
    padding: 6px 7px 2px;
    line-height: 20px;
    display: block;
    align-self: flex-start;
`

export const MostviewContent = styled.div`
    margin-left: 8px;
`

export const MostviewCategory = styled(Link)`
    text-decoration: none;
    text-transform: uppercase;
    color: #222;
    font-size: 10px;
    display: block;
`

export const MostviewTitle = styled(Link)`
    margin: 5px 0;
    text-decoration: none;
    height: 55px;
    color: #222;
    font-size: 15px;
    font-weight: bold;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media screen and (max-width: 767px) {
        margin-left: 10px;
        font-size: 18px;
        -webkit-line-clamp: 4;
        font-weight: 500;
        height: auto;
        align-self: flex-start;
    }

    @media screen and (max-width: 475px) {
        font-size: 15px;
    }
`

export const MostviewDesc = styled.p`
    color: #222;
    font-size: 12px;
    line-height: 1.17;
    opacity: .7;
    margin-bottom: 7px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
`

export const MostviewDate = styled.span`
    color: #9b9b9b;
    font-size: 11px;
`